"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var CDN_service_1 = require("./CDN.service");
var Http_service_1 = require("./http/Http.service");
var DEFAULT_LANGUAGE_CODE = 'en-US';
var LanguageService = /** @class */ (function () {
    function LanguageService(httpService, cdnService) {
        this.httpService = httpService;
        this.cdnService = cdnService;
        this.languageCode = DEFAULT_LANGUAGE_CODE;
    }
    /*
        Loads language JSON files from CDN.
        See more here: https://github.com/seismic/seismic-i18n-cdn
     */
    LanguageService.prototype.getTranslations = function (languageCode, appName, subFolder) {
        if (subFolder === void 0) { subFolder = 'Default'; }
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, formattedLanguageCode, url, strData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cdnService.getI18nCDNURL()];
                    case 1:
                        baseUrl = _a.sent();
                        formattedLanguageCode = this.normalizeLanguageCode(languageCode);
                        url = "".concat(baseUrl, "/static/seismic-i18n/").concat(appName, "/").concat(subFolder, "/").concat(formattedLanguageCode, ".json");
                        return [4 /*yield*/, this.httpService.get(url, {
                                cache: 'variable',
                                ignoreGlobalHeaders: true,
                            })];
                    case 2:
                        strData = _a.sent();
                        if (typeof strData === 'string') {
                            return [2 /*return*/, JSON.parse(strData)];
                        }
                        return [2 /*return*/, strData];
                }
            });
        });
    };
    LanguageService.prototype.getLanguage = function () {
        return this.languageCode || DEFAULT_LANGUAGE_CODE;
    };
    LanguageService.prototype.setLanguageCode = function (userLanguage, defaultBrowserLanguage) {
        var languageCode = userLanguage || this.getDefaultLanguage(defaultBrowserLanguage);
        this.languageCode = this.normalizeLanguageCode(languageCode);
    };
    /*  Get the supported language list. for ticket BASE-779
     */
    LanguageService.prototype.getSupportedLanguages = function () {
        return [
            'de-DE',
            'es-ES',
            'en-US',
            'en-GB',
            'zh-CN',
            'zh-TW',
            'fr-FR',
            'fr-CA',
            'it-IT',
            'ja-JP',
            'ko-KR',
            'pt-BR',
            'ru-RU',
            'id-ID',
            'tr-TR',
            'nl-NL',
        ];
    };
    LanguageService.prototype.getDefaultLanguage = function (defaultBrowserLanguage) {
        var lang = defaultBrowserLanguage ||
            (navigator.languages && navigator.languages[0]) ||
            navigator.language ||
            navigator.browserLanguage ||
            navigator.userLanguage ||
            '';
        // special means the langcode is not in our list, but we need to support.
        var specialSupportLanguage = {
            zh: 'zh-CN',
            en: 'en-US',
            nl: 'nl-NL',
            'zh-Hans-CN': 'zh-CN',
            'zh-Hans': 'zh-CN',
            'zh-Hant-TW': 'zh-TW',
            'zh-Hant': 'zh-TW',
        };
        if (specialSupportLanguage[lang]) {
            return specialSupportLanguage[lang];
        }
        // use browser language only when it is in our support list.
        var supportBrowserLanguageList = this.getSupportedLanguages();
        var supportBrowserLanguage = supportBrowserLanguageList.find(function (sl) {
            // deal with the input like lang='zh-cn', capital insensitive
            return sl.toUpperCase() === lang.toUpperCase();
        });
        if (supportBrowserLanguage)
            return supportBrowserLanguage;
        // Fix AS-2620
        var compatibleLanguages = ['en-US', 'zh-CN', 'fr-FR', 'de-DE', 'it-IT', 'ja-JP', 'ko-KR', 'pt-BR', 'es-ES'];
        var compatibleLanguage = compatibleLanguages.find(function (cl) {
            return cl.split('-')[0].toUpperCase() === lang.toUpperCase();
        });
        if (compatibleLanguage)
            return this.normalizeLanguageCode(compatibleLanguage);
        // final default is en-US;
        return DEFAULT_LANGUAGE_CODE;
    };
    LanguageService.prototype.normalizeLanguageCode = function (languageCode) {
        var languagesFormat = {
            zh: 'zh-CN',
            en: 'en-US',
            nl: 'nl-NL',
            'zh-hans-cn': 'zh-CN',
            'zh-hans': 'zh-CN',
            'zh-hant-tw': 'zh-TW',
            'zh-hant': 'zh-TW',
            'de-de': 'de-DE',
            'es-es': 'es-ES',
            'en-us': 'en-US',
            'en-gb': 'en-GB',
            'zh-cn': 'zh-CN',
            'zh-tw': 'zh-TW',
            'fr-fr': 'fr-FR',
            'fr-ca': 'fr-CA',
            'it-it': 'it-IT',
            'ja-jp': 'ja-JP',
            'ko-kr': 'ko-KR',
            'pt-br': 'pt-BR',
            'ru-ru': 'ru-RU',
            'id-id': 'id-ID',
            'tr-tr': 'tr-TR',
            'nl-nl': 'nl-NL',
        };
        if (languageCode && languagesFormat[languageCode.toLocaleLowerCase()]) {
            return languagesFormat[languageCode.toLocaleLowerCase()];
        }
        return DEFAULT_LANGUAGE_CODE;
    };
    LanguageService = __decorate([
        (0, CommonService_decorator_1.CommonService)('LanguageService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService, CDN_service_1.CDNService])
    ], LanguageService);
    return LanguageService;
}());
exports.LanguageService = LanguageService;
//# sourceMappingURL=Language.service.js.map